module.exports = __webpack_public_path__ + "static/media/hk-vitebsk-wb.1f98c825.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/hk-vitebsk-wb.svg
// module id = 530
// module chunks = 0